import styled from 'react-emotion';

export default styled('div')`
  width: ${props => (props.width ? `${props.width}px` : '100%')};
  height: ${props => (props.height ? `${props.height}px` : '1px')};
  ${props => (props.width ? `align-self: center` : null)};
  background-color: ${props =>
    props.color ? props.color : 'rgba(0, 0, 0, 0.1)'};
`;
